import { render, staticRenderFns } from "./TinyInfo.vue?vue&type=template&id=74e9d699&scoped=true"
import script from "./TinyInfo.vue?vue&type=script&lang=ts"
export * from "./TinyInfo.vue?vue&type=script&lang=ts"
import style0 from "./TinyInfo.vue?vue&type=style&index=0&id=74e9d699&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e9d699",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74e9d699')) {
      api.createRecord('74e9d699', component.options)
    } else {
      api.reload('74e9d699', component.options)
    }
    module.hot.accept("./TinyInfo.vue?vue&type=template&id=74e9d699&scoped=true", function () {
      api.rerender('74e9d699', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/TinyInfo.vue"
export default component.exports